import React from 'react';
import './DifficultyPill.scss';

const DifficultyPill = ({ difficultyScore, dictionary }) => {
  if (difficultyScore == null) return null;

  const getDifficultyLabel = (score) => {
    if (score <= 0.25) {
      return {
        label: dictionary.easy,
        className: 'easy',
      };
    } else if (score <= 0.5) {
      return {
        label: dictionary.medium,
        className: 'medium',
      };
    } else if (score <= 0.75) {
      return {
        label: dictionary.hard,
        className: 'hard',
      };
    } else {
      return {
        label: dictionary.veryHard,
        className: 'very-hard',
      };
    }
  };

  const { label, className } = getDifficultyLabel(difficultyScore);

  return (
    <div className="c-difficulty-pill-wrapper">
      <div className={`c-difficulty-pill c-difficulty-pill--${className}`}>{label}</div>
    </div>
  );
};

export default DifficultyPill;
